import { heroCards, shellStats } from '@/mocks/home';

const toneStyles: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-foreground-950',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function HeroSection() {
  return (
    <section id="top" className="hll-scroll-anchor w-full bg-background-100 pb-12 pt-10 md:pb-16 md:pt-14">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="w-full max-w-2xl hll-rise">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1">
              <span className="flex h-4 w-4 items-center justify-center text-primary-600">
                <i className="ri-record-circle-line text-sm"></i>
              </span>
              <span className="text-xs tracking-wide text-primary-700">实时归档 · 多合集并列速览</span>
            </div>
            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-[2.7rem] md:leading-[1.2]">
              黑料吃瓜网 · 视频、图片与实锤证据
              <span className="text-primary-600">一页看全</span>
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              这里把黑料吃瓜网视频与黑料吃瓜网图片集中归档，按合集整理好，方便核实锤、查证据；黑料吃瓜网高清资源支持直接下载，找图找视频不用来回翻。
            </p>
          </div>
          <div className="flex w-full flex-col gap-3 sm:flex-row lg:w-auto hll-rise">
            <a
              href="#index"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-layout-grid-line text-base"></i>
              </span>
              浏览合集索引
            </a>
            <a
              href="#resource"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3 text-sm text-foreground-900 transition-colors hover:border-foreground-500"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-folder-download-line text-base"></i>
              </span>
              下载高清资源
            </a>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:mt-10 lg:grid-cols-12">
          {heroCards.slice(0, 1).map((card) => (
            <article
              key={card.id}
              className="group relative h-[300px] overflow-hidden rounded-lg border border-background-300/60 md:h-[460px] lg:col-span-6 hll-rise"
            >
              <img
                src={card.image}
                alt={`${card.title} - 黑料吃瓜网合集封面`}
                title={`${card.title} 黑料吃瓜网高清素材`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs ${toneStyles[card.tone]}`}>
                  {card.kicker}
                </span>
                <h3 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-2xl">{card.title}</h3>
                <p className="mt-2 max-w-lg text-sm leading-relaxed text-background-200">{card.desc}</p>
                <div className="mt-4 flex items-center gap-3 text-xs text-background-300">
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-stack-line text-sm"></i>
                    </span>
                    {card.meta}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-time-line text-sm"></i>
                    </span>
                    2 小时前更新
                  </span>
                </div>
              </div>
            </article>
          ))}

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-6 lg:grid-cols-1">
            {heroCards.slice(1).map((card) => (
              <article
                key={card.id}
                className="group relative h-[220px] overflow-hidden rounded-lg border border-background-300/60 hll-rise"
              >
                <img
                  src={card.image}
                  alt={`${card.title} - 黑料吃瓜网素材`}
                  title={`${card.title} 黑料吃瓜网图片`}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
                <div className="absolute inset-y-0 left-0 flex max-w-[80%] flex-col justify-center p-5">
                  <span className={`w-fit rounded-full px-3 py-1 text-xs ${toneStyles[card.tone]}`}>{card.kicker}</span>
                  <h3 className="mt-3 font-heading text-lg font-bold text-background-50">{card.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-background-200">{card.desc}</p>
                  <span className="mt-3 text-xs text-background-300">{card.meta}</span>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-4">
          {shellStats.map((stat) => (
            <div
              key={stat.label}
              className="flex items-baseline justify-between rounded-lg border border-background-300/60 bg-background-50 px-4 py-4"
            >
              <span className="text-xs text-foreground-500">{stat.label}</span>
              <span className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{stat.value}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}